import { WarehouseType } from '@enums/warehouse-type';

import { UserSettingType } from '@core/enums/user-setting-type';

export const USER_LOADED: string = 'USER_LOADED';
export const WAREHOUSE_TYPE_INIT: string = 'WAREHOUSE_TYPE_INIT';
export const CURRENT_MENY_ITEM: string = 'CURRENT_MENY_ITEM';
export const SET_RESTART_SERVICE_REQUIRED: string = 'SET_RESTART_SERVICE_REQUIRED';
export const SET_FILTER: string = 'SET_FILTER';
export const CLEANUP_STATES: string = 'CLEANUP_STATES';

export const COLUMNS_SETTINGS_INIT: string = 'COLUMNS_SETTINGS_INIT';
export const COLUMNS_SETTINGS_VISIBILITY_CHANGED: string = 'COLUMNS_SETTINGS_VISIBILITY_CHANGED';
export const COLUMNS_SETTINGS_WIDTH_CHANGED: string = 'COLUMNS_SETTINGS_WIDTH_CHANGED';
export const COLUMNS_SETTINGS_DISPLAY_CHANGED: string = 'COLUMNS_SETTINGS_DISPLAY_CHANGED';
export const COLUMNS_SETTINGS_ORDER_CHANGED: string = 'COLUMNS_SETTINGS_ORDER_CHANGED';

export const userLoaded = (userSession?: any) => {
    return {
        type: USER_LOADED,
        payload: userSession,
    };
};

export const initWarehouseType = (type?: WarehouseType) => {
    return {
        type: WAREHOUSE_TYPE_INIT,
        payload: type,
    };
};

export const setCurrentMenuItem = (key: string) => {
    return {
        type: CURRENT_MENY_ITEM,
        payload: key,
    };
};

export const setRestartServiceRequired = (value: boolean) => {
    return {
        type: SET_RESTART_SERVICE_REQUIRED,
        payload: value,
    };
};

export const setFilter = (value: any, context: string) => {
    return {
        type: SET_FILTER,
        payload: value,
        context: context,
    };
};

export const cleanupStates = () => {
    return {
        type: CLEANUP_STATES,
    };
};

export const initColumnsSettings = (settingType: UserSettingType, settingContext: string, initialData: any) => ({
    type: COLUMNS_SETTINGS_INIT,
    settingType,
    settingContext,
    payload: { initialData },
});

export const changeColumnVisibility = (settingType: UserSettingType, settingContext: string, property: any) => ({
    type: COLUMNS_SETTINGS_VISIBILITY_CHANGED,
    settingType,
    settingContext,
    payload: { name: property.name, value: property.value },
});

export const changeColumnWidth = (settingType: UserSettingType, settingContext: string, property: any) => ({
    type: COLUMNS_SETTINGS_WIDTH_CHANGED,
    settingType,
    settingContext,
    payload: { name: property.name, value: property.value },
});

export const changeDisplaySettings = (settingType: UserSettingType, settingContext: string, property: any) => ({
    type: COLUMNS_SETTINGS_DISPLAY_CHANGED,
    settingType,
    settingContext,
    payload: { name: property.name, value: property.value },
});

export const changeColumnOrder = (settingType: UserSettingType, settingContext: string, property: any) => ({
    type: COLUMNS_SETTINGS_ORDER_CHANGED,
    settingType,
    settingContext,
    payload: { value: property.value },
});
